import { connect, ConnectedProps } from 'react-redux';
import { StateType } from '../../../state/reducers';

const mapState = ({ queryParams }: StateType) => ({
  type: queryParams.type,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
